import React, { useReducer, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { parseLocation } from 'utils/Routing';
import { getProject } from 'utils/ProjectsUtils';
import { getSectionSettings } from 'utils/ProjectConfigurationUtil';


const reducer = (state, action) => {
  switch (action.type) {
    case 'DRAWER_CHANGED':
      return {
        ...state,
        drawerOpen: action.payload,
      };
    case 'ROUTE_CHANGED':
      return {
        ...state,
        selectedProject: action.payload.selectedProject,
        currentModule: action.payload.currentModule,
        currentModuleFilter: action.payload.currentModuleFilter,
        subModule1: action.payload.subModule1,
        subModule1Filter: action.payload.subModule1Filter
      }
    case 'PROJECT_CHANGED':
      return {
        ...state,
        selectedProject: action.payload
      };
    case "MODULE_CHANGED":
      return {
        ...state,
        currentModule: action.payload
      }
    case "PROJECT_DATA_CHANGED":
      return {
        ...state,
        selectedProjectData: action.payload
      }
    case "MOUNTED_CHANGED":
      return {
        ...state,
        mounted: action.payload
      }
    case "THEME_PALETTE_CHANGED":
      const newType = state.themePaletteType === "dark" ? 'light' : 'dark';
      localStorage.setItem('themePaletteType', newType);
      return {
        ...state,
        themePaletteType: newType
      }
    case "FORCE_UPDATE":
      const newDate = new Date().toString();
      return {
        ...state,
        forceUpdate: newDate
      }
    default: return state;
  }
};

let initialState = {
  drawerOpen: false,
  selectedProject: null,
  currentModule: null,
  currentModuleFilter: null,
  subModule1: null,
  subModule1Filter: null,
  selectedProjectData: null,
  mounted: true,
  forceUpdate: new Date().toString(),
  themePaletteType: localStorage.getItem('themePaletteType') ? localStorage.getItem('themePaletteType') : 'light'
};

const ApplicationContext = React.createContext(initialState);

const ApplicationProvider = ({ children }) => {
  let location = useLocation();
  const routeParams = parseLocation(location.pathname);
  initialState = { ...initialState, ...routeParams };
  initialState.drawerOpen = initialState.selectedProject !== null;



  const [state, dispatch] = useReducer(reducer, initialState);

  // context modifier
  const updateDrawerStatus = (trueOrFalse) => {
    dispatch({ type: "DRAWER_CHANGED", payload: trueOrFalse });
  };

  // context modifier
  const updateSelectedProject = (projectId) => {
    dispatch({ type: "PROJECT_CHANGED", payload: projectId });
  }

  // context modifier
  const updateCurrentModule = (currentModule) => {
    dispatch({ type: "MODULE_CHANGED", payload: currentModule });
  }

  // context modifier
  const updateRoute = (params) => {
    dispatch({ type: "ROUTE_CHANGED", payload: params });
  }

  // context modifier
  const toggleTheme = (e) => {
    dispatch({ type: "THEME_PALETTE_CHANGED" });
  }

  // context modifier
  const forceUpdate = (e) => {
    dispatch({ type: "FORCE_UPDATE" })
  }

  // context modifier
  /*const updateMounted = (Bool) => {
    dispatch({ type: 'MOUNTED_CHANGED', payload: Bool })
  }*/

  if (state.selectedProject !== initialState.selectedProject) {
    updateSelectedProject(initialState.selectedProject);
  }

  useEffect(() => {
    let mounted = state.mounted;
    async function asyncEffects() {
      const fetchProjData =  getProject(state.selectedProject);
      const fetchSectionSettings = getSectionSettings(undefined, undefined, undefined, undefined, {projectID:state.selectedProject});
      const [ projectData, sectionSetting ] = await Promise.all([fetchProjData, fetchSectionSettings]);
      projectData.sectionSetting = sectionSetting.data;
      mounted && dispatch({ type: "PROJECT_DATA_CHANGED", payload: projectData });
    };

    state.mounted && state.selectedProject && asyncEffects();

    return () => mounted = false;

  }, [state.selectedProject, state.mounted, state.forceUpdate]);

  useEffect(() => {
    updateRoute(parseLocation(location.pathname));
    updateDrawerStatus(initialState.selectedProject !== null);
  }, [location]);

  return (
    <ApplicationContext.Provider
      value={{
        drawerOpen: state.drawerOpen,
        selectedProject: state.selectedProject,
        currentModule: state.currentModule,
        currentModuleFilter: state.currentModuleFilter,
        subModule1: state.subModule1,
        subModule1Filter: state.subModule1Filter,
        selectedProjectData: state.selectedProjectData,
        themePaletteType: state.themePaletteType,
        toggleTheme,
        updateDrawerStatus,
        updateSelectedProject,
        updateCurrentModule,
        forceUpdate
      }}
    >
      {children}
    </ApplicationContext.Provider>
  )
};

export { ApplicationContext, ApplicationProvider };